<template>
    <div class="travelItem" @click="onReviewClick($event)">
        <div class="travelItem-pic">
            <img v-lazy="review.iconImage" />
            <span class="travelItem-picTitle">{{review.title}}</span>
        </div>
        <div class="travelItem-info">
            <div class="travelItem-top">
                <div class="travelItem-top-l">
                    <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/userAvatar.png">
                    <span class="travelItem-top-name">{{review.author}}</span>
                </div>
                <div class="travelItem-top-r js-checkUpvoteBtn" @click="onUpvoteClick($event)">
                    <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/praiseNewBtn-1.png" v-if="!review.isUpvote">
                    <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/praiseActiveNewBtn-1.png" v-if="review.isUpvote">
                    <span
                        class="travelItem-top-praiseNum">{{review.score}}
                    </span>
                </div>
            </div>
            <div class="travelItem-cruiseName">{{review.route}}</div>
            <div class="travelItem-cruiseDate">{{review.shipName}}&nbsp;&nbsp;&nbsp;{{review.sailDate}}</div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
export default {
    name: "CruiseReviewItem",
    props: {
        review: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    methods: {
        onReviewClick (e) {
            e.stopPropagation()
            this.$router.push(`/Rccl.Review/Travel/d-n-n-0-0-${this.review.id}.html`)
        },
        async onUpvoteClick (e) {
            e.stopPropagation()
            if (this.review.isUpvote) {
                this.$alert.show("您已点过赞了")
            } else {
                this.$loading.show()
                const { success, data , errMsg } = await api.review.upvote({
                    userId: this.$store.state.user.userReviewToken,
                    articalId: this.review.id
                })
                
                if (data != this.$store.state.user.userReviewToken) {
                    this.$store.commit('SET_REWARD_TOKEN', data)
                }
                this.$loading.hide()
                if (!success) {
                    this.$alert.show(errMsg)
                    return
                }
                this.review.score++
                this.review.isUpvote = true

            }
        }
    }
}
</script>

<style lang="less" scoped>
.travelItem {
    margin-bottom: 10px;
    .travelItem-pic {
        position: relative;
        > img {
            width: 100%;
            display: block;
        }
        > span.travelItem-picTitle {
            position: absolute;
            bottom: 14px;
            left: 20px;
            font-family: PingFang-SC-Medium;
            font-size: 14px;
            color: #FFFFFF;
            letter-spacing: 0;
        }
    }
    .travelItem-info {
        background-color: #fff;
        padding: 16px 15px 20px 15px;
        .travelItem-top {
            overflow: hidden;
            .travelItem-top-l {
                float: left;
                padding: 4px;
                > img {
                    width: 15px;
                    font-size: 0;
                    vertical-align: middle;
                }
                > span {
                    font-family: PingFang-SC-Medium;
                    font-size: 12px;
                    color: #333333;
                    letter-spacing: 0;
                    margin-left: 6px;
                    vertical-align: middle;
                }
            }
            .travelItem-top-r {
                float: right;
                padding: 4px;
                    > img {
                    width: 24px;
                    font-size: 0;
                    vertical-align: middle;
                }
                > span {
                    font-family: PingFang-SC-Medium;
                    font-size: 12px;
                    color: #666666;
                    letter-spacing: 0;
                    margin-left: 2px;
                    vertical-align: middle;
                }
            }
        }
        .travelItem-cruiseName {
            font-family: PingFang-SC-Medium;
            font-size: 12px;
            color: #333333;
            margin-top: 4px;
        }
        .travelItem-cruiseDate {
            font-family: PingFang-SC-Medium;
            font-size: 12px;
            color: #666666;
            margin-top: 6px;
        }
    }
    }
</style>